<div mat-dialog-content>
    <h3>Unable to connect to service.</h3>
    <p>If this problem persists, please contact <a href="mailto:jackm@custom-group.com">jackm&#64;custom-group.com</a>.</p>
</div>

<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-flat-button color="primary" (click)="refresh()">Refresh</button>
</div>
